import { Component, OnInit } from '@angular/core';
//import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { NavController } from '@ionic/angular';
import { NavExtrasService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { AnalyticsService } from '../analytics.service';

@Component({
  selector: 'app-elections',
  templateUrl: './elections.page.html',
  styleUrls: ['./elections.page.scss'],
})
export class ElectionsPage implements OnInit {

  loading: Boolean = false;
  lat: Number;
  long: Number;
  electionDates: any = [];
  elections: any = [];
  volunteerElections: any = [];
  results: [] = [];
  selectedElectionDate: String;

  apiError: boolean = false;
  cachedElectionChoicesAvailable: boolean = false;

  outOfTopCity: boolean = true;

  apiKey: string;
  headerBranding: string;
  clientElectionPageText: string;

  preventAddressSave: boolean;
  collectAnalytics: Boolean;
  isBallotpediaWebApp: Boolean;

  stateName: String;
  votingInfoExists: Boolean = false;

  captureEmail: Boolean;
  condensedInput: Boolean;
  captureBallotpediaEmail: Boolean;

  constructor(
    private storage: Storage,
    private navController: NavController,
    private navExtraService: NavExtrasService,
    private httpClient: HttpClient,
    private configService: ConfigService,
    private analyticsService: AnalyticsService
    ) {}

  async ngOnInit() {

    // Initiate Storage
    await this.storage.create();

    let res = await this.configService.getConfiguration();


   // let res = await this.configService.getConfiguration();

    this.apiKey = res["key"];
    this.headerBranding = res["headerBranding"];
    this.clientElectionPageText = res["clientElectionPageText"];
    this.preventAddressSave = res["preventAddressSave"];
    this.collectAnalytics = res["collectAnalytics"];
    this.isBallotpediaWebApp = res["isBallotpediaWebApp"];
    this.captureEmail = res["email"].capture;
    this.captureBallotpediaEmail = res["email"].captureBallotpediaEmail;
    this.condensedInput = res["condensedInput"];

    this.getElections();
  }

  async getElections() {
    console.log('get elections called')
    this.loading = true;



    if (!this.preventAddressSave) {
      try {
        this.lat = await this.storage.get('lat');
        this.long = await this.storage.get('long');
      } catch(e) {
        console.log(e)
      }
    } else {
      this.lat = this.navExtraService.getCoords().lat;
      this.long = this.navExtraService.getCoords().lng;
    }


    console.log('lat');
    console.log(this.lat);

    let response: any;


    /*

      FOR DEV:
      Run API4 locally to hit the SB endpoints.
      Change the address here to your local router's IP address.
      localhost won't work since a phone can't understand it.

    */
        try {

          let headers;

          if (this.apiKey) {
            headers = {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-api-key': this.apiKey
            }
          } else {
            headers = {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          }

        response = await fetch(`https://api4.ballotpedia.org/myvote_redistricting?long=${this.long}&lat=${this.lat}&include_volunteer=true`, {
          method: 'GET',
          headers: headers,
        })

        response = await response.json();

        console.log('response');
        console.log(response);

        if (!response.success) {
          console.log('API fetch error');
          this.apiError = true;

        } else if (response.success && response.data.districts) {
          for (let district of response.data.districts) {
            if(district.type === 'State') {
              this.stateName = district.name;
              this.navExtraService.setStateNameAndAbbreviation({
                stateName: district.name,
                stateAbbreviation: district.state
              });
            }

            if ((district.type === 'City' || district.type === 'City-town') && district.covered === true) {
              this.outOfTopCity = false;
            }
          }

          this.navExtraService.setCoverageDisclaimerBoolean(this.outOfTopCity);
          if (!this.preventAddressSave) {
            await this.storage.set('outOfTopCity', this.outOfTopCity);
          } 

          // cache results if at least one staff- or volunteer-entered election
          if ((response.data.elections && response.data.elections.length > 0) || (response.data.volunteer_elections && response.data.volunteer_elections.length > 0)) {
            if (!this.preventAddressSave) { 
              await this.storage.set('cachedElections', response);
              await this.storage.set('cachedElectionChoicesAvailable', true);
            }
          }

          // This is for consolidating elections of the same dates.
          if(response.data.elections) {
            this.elections = response.data.elections

            response.data.elections.forEach((election) => {
              this.electionDates.push({ date: election.date,  candidate_lists_complete: election.candidate_lists_complete, cached: false });

              // If an election has a voting object attached, send to our service to be used in our voting info page
              // currently only used for the 2020 general election
              if(election.voting_info && election.date == "2020-11-03") {
                this.votingInfoExists = true;
                this.navExtraService.setVotingInfo(election.voting_info[0]);

                // Pre-populate the Data Service in case the voter clicks on "continue to ballot" on voting info page:
                this.navExtraService.setElection(election);
              }
            })
          }

          // consolidate volunteer elections
          if(response.data.volunteer_elections) {
            response.data.volunteer_elections.forEach((volunteerElection) => {
              this.volunteerElections.push(volunteerElection);

              if ( this.electionDates.findIndex(e => e.date === volunteerElection.date) === -1 ) {
                this.electionDates.push({ date: volunteerElection.date, candidate_lists_complete: true, cached: false })
              }
            });
          }

          // sort all of the election dates, including dates with only volunteer elections
          this.electionDates.sort(function(a, b) {
            return +new Date(a.date) - +new Date(b.date);
          });

          // Lastly, send address, email, lat,lng and districts to Pardot
          // don't include district IDs for any local subdivisions

          if (this.captureEmail && this.captureBallotpediaEmail && this.condensedInput) {

            let address = this.navExtraService.getStringAddress();
            let email = this.navExtraService.getEmailAddress();

            if (email) {
              try {
                const districtIDs = response.data.districts.map(district => {
                  if (!district.type.includes('subdivision')) {
                    return district.id;
                  }
                });
                fetch(`https://ballotpedia.org/whatcounts_subscribe_sbl.php?email=${email}&address=${address}&lat=${this.lat}&long=${this.long}&districts=${districtIDs.join(',')}`,
                  {
                    method: 'GET',
                    headers: {}
                  })
              } catch(e) {
                console.log(e);
              }
            }
          }
        }
      } catch (e) {
        this.apiError = true;
        this.cachedElectionChoicesAvailable = await this.storage.get('cachedElectionChoicesAvailable');

        // If no internet or API error, use last cached elections response.

        // TODO: make error handling same as above
        if (this.apiError && this.cachedElectionChoicesAvailable) {

          response = await this.storage.get('cachedElections');
          this.outOfTopCity = await this.storage.get('outOfTopCity');

          if (response.data.districts) {
            for (let district of response.data.districts) {
              if(district.type === 'State') {
                this.stateName = district.name;
                this.navExtraService.setStateNameAndAbbreviation({
                  stateName: district.name,
                  stateAbbreviation: district.state
                });
                break;
              }
            }
          }

            // This is for consolidating elections of the same dates.
            if(response.data.elections) {
              this.elections = response.data.elections

              response.data.elections.forEach((election) => {
                this.electionDates.push({ date: election.date,  candidate_lists_complete: election.candidate_lists_complete, cached: false });

              // If an election has a voting object attached, send to our service to be used in our voting info page
              // currently only used for the 2020 general election
              if(election.voting_info && election.date == "2020-11-03") {
                  this.votingInfoExists = true;
                  this.navExtraService.setVotingInfo(election.voting_info[0]);

                  // Pre-populate the Data Service in case the voter clicks on "continue to ballot" on voting info page:
                  this.navExtraService.setElection(election);
                }
              })
            }

            // consolidate volunteer elections
            if(response.data.volunteer_elections) {
              response.data.volunteer_elections.forEach((volunteerElection) => {
                this.volunteerElections.push(volunteerElection);

                if ( this.electionDates.findIndex(e => e.date === volunteerElection.date) === -1 ) {
                  this.electionDates.push({ date: volunteerElection.date, candidate_lists_complete: true, cached: false })
                }
              });
            }

            // sort all of the election dates, including dates with only volunteer elections
            this.electionDates.sort(function(a, b) {
              return +new Date(a.date) - +new Date(b.date);
            });

        }

      } finally {
        this.loading = false;

      }
      if ((this.elections.length < 1  || !this.elections) && (!this.apiError && !this.cachedElectionChoicesAvailable) ) {
           this.navController.navigateForward(`/noelections`);
      }
  }

  navigateToVotingInfo() {
    this.navController.navigateForward(`/voting-info`);
  }

  onElectionChosen = async (electionDate) => {

    // Temporary solution to help with iOS scroll
    // Scroll to top of Parent page.
    // if (this.isBallotpediaWebApp) {
    //   const parent_origin = "https://ballotpedia.org";
    //   parent.postMessage({'task': 'scroll_top'}, parent_origin);
    // }

    if(this.collectAnalytics) {
      this.analyticsService.trackEvent('view results');
    }

    // Set the normal election and any volunteer elections with our data service
    // We display this information on the results page
    // Finally, navigate to the results page component
    // send a deep copy of the election object, because the ballot page makes changes to the original object
    // these changes can cause certain disclaimers and races to not appear if the user navigates back and then to the same election date
    const chosenElection = this.elections.find(e => e.date === electionDate.date);
    if (chosenElection) {
      const chosenElectionCopy = JSON.parse(JSON.stringify(chosenElection));
      this.navExtraService.setElection(chosenElectionCopy);
    } else {
      this.navExtraService.setElection(null);
    }
    this.navExtraService.setVolunteerElection(this.volunteerElections.find(ve => ve.date === electionDate.date));
    this.navController.navigateForward(`/ballot`);
}

visitExternalLink(URL: string) {
  window.open(URL, `_system`);
}


}